module.exports = __webpack_public_path__ + "static/media/yuce006.1e6fb7ad.png";